import { IconBase, IconComponent } from './BaseIcon';

export const CheckMark: IconComponent = (props) => (
  <IconBase {...props}>
    <polygon points="13.27 23.74 6.04 16.53 7.45 15.11 13.27 20.91 24.67 9.52 26.08 10.94 13.27 23.74" />
  </IconBase>
);
